import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { CreateEditOrdenCompraComponent } from '../create-edit-orden-compra/create-edit-orden-compra.component';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';
import { ordenCompraLst } from 'src/app/models/ordenCompraLst';
import { IndexDetalleOrdenCompraComponent } from '../index-detalle-orden-compra/index-detalle-orden-compra.component';
import { DetalleOrdenCompraReporteComponent } from '../detalle-orden-compra-reporte/detalle-orden-compra-reporte.component';
import { ConfirmarCreacionOrdenCompraComponent } from '../confirmar-creacion-orden-compra/confirmar-creacion-orden-compra.component';

@Component({
  selector: 'app-index-orden-compra',
  templateUrl: './index-orden-compra.component.html',
  styleUrls: ['./index-orden-compra.component.scss'],
})
export class IndexOrdenCompraComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public ordenCompraSvc: OrdenCompraService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: ordenCompraLst[] = [];
    this.displayedColumns = [
      'fechaCreacion',
      //  'fechaFinalizada',
      'numeroRegistros',
      'estado',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<ordenCompraLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getOrdenesCompra(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getOrdenesCompra(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.ordenCompraSvc
      .getOrdenesCompra(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<ordenCompraLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getOrdenesCompra(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getOrdenesCompra(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getOrdenesCompra(this.pageIndex, this.pageSize);
  }

  openDialogCreate(): void {
    let dialogRef = this.dialog.open(ConfirmarCreacionOrdenCompraComponent);
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result) {
        console.log('dialogo cerrado - CREA LA ORDEN DE COMPRA');
        this.ordenCompraSvc
          .addOrdenCompra({ id: '00000000-0000-0000-0000-000000000000' })
          .subscribe((res) => {
            console.log('resultado crear: ', res);
            if (res) {
              this.alertify.success('Orden de compra creada');
              this.getOrdenesCompra(this.pageIndex, this.pageSize);
            } else {
              this.alertify.error('La orden de compra no se ha podido crear');
            }
          });
      } else {
        console.log('dialogo cerrado - NO crea nada');
      }
    });
  }

  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditOrdenCompraComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getOrdenesCompra(this.pageIndex, this.pageSize);
      }
    });
  }

  delete(obj: any) {
    console.log(obj);
    this.alertify.confirm(
      'Confirma que quiere eliminar el la orden de compra?',
      () => {
        this.ordenCompraSvc.deleteOrdenCompra(obj.id).subscribe((res) => {
          if (res) {
            this.getOrdenesCompra(this.pageIndex, this.pageSize);
            this.alertify.success('orden de compra eliminada.');
          } else {
            this.alertify.error('La orden de compra no se ha podido eliminar.');
          }
        });
      }
    );
  }

  abrirModalDeportistas(obj: any): void {
    let dialogRef = this.dialog.open(IndexDetalleOrdenCompraComponent, {
      data: obj.id,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getOrdenesCompra(this.pageIndex, this.pageSize);
    });
  }

  enviar(obj: any): void {
    this.ordenCompraSvc.getValorOrdenCompra(obj.id).subscribe((valorOc) => {
      console.log(
        'El valor de la orden es de:',
        valorOc.toLocaleString('es-ES')
      );

      this.alertify.confirm(
        'Confirma el envio de la orden de compra? no podrá hacer cambios despues, El valor es: $' +
          valorOc.toLocaleString('es-ES'),
        () => {
          this.ordenCompraSvc
            .validarOrdenCompra(obj.id)
            .subscribe((validacion) => {
              if (validacion.valida) {
                this.ordenCompraSvc
                  .presentarOrdenCompra(obj.id)
                  .subscribe((result) => {
                    if (result) {
                      this.getOrdenesCompra(this.pageIndex, this.pageSize);
                      this.alertify.success('Orden de compra enviada');
                      /*       window.open(
          'https://biz.payulatam.com/L0caab66D12E6B2',
          '_blank'
        ); */
                    } else {
                      this.alertify.error(
                        'La orden de compra no se puede presentar'
                      );
                    }
                  });
              } else {
                switch (validacion.tipo) {
                  case 1:
                    this.alertify.error(
                      'Deportistas en la orden de compra sin horarios, debe asignarles horario para permitir enviar la orden de compra'
                    );
                    break;
                  case 2:
                    this.alertify.error(
                      'Deportistas en la orden de compra sin foto, debe asignarles foto para permitir enviar la orden de compra'
                    );
                    break;
                  case 3:
                    this.alertify.error(
                      'Saldo insuficiente para enviar la orden de compra'
                    );
                    break;
                }
              }
            });
        }
      );
    });
  }

  abrirDetalleOrdenCompra(obj: any): void {
    this.dialog.open(DetalleOrdenCompraReporteComponent, {
      data: obj.id,
    });
  }

  generarPdf(obj: any) {
    // alert(obj.id);

    this.ordenCompraSvc.getOrdenCompraPdf(obj.id || '').subscribe((result) => {
      console.log('result: ', result);
      let blob = new Blob([result], { type: 'application/pdf' });
      var downloadURL = window.URL.createObjectURL(result);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = obj.id || 'OrdenCompra' + '.pdf';
      link.click();
    });
  }

  getValorOrdenCompraFinal(obj: any) {
    this.ordenCompraSvc
      .getValorFinalOrdenCompra(obj.id)
      .subscribe((valorOc) => {
        console.log('el valor final de la orden es:', valorOc);
        this.alertify.confirm(
          'El valor de la orden de compra es: $' +
            valorOc.toLocaleString('es-ES'),
          () => {}
        );
      });
  }
}
